<template>
  
      <div class="row" v-if="firm">

        <div class="form-group col-md-3">
            <label for="companyInput" v-if="firm.firmType == 1">{{ $t('project.company.form.accounting.company') }}</label>
            <label for="companyInput" v-if="firm.firmType == 2">{{ $t('project.company.form.lawyer.company') }}</label>
            
            <multiselect v-model="localFirm.company" id="ajax" open-direction="bottom" 
                :options="firms" :multiple="false" :searchable="true" :loading="isLoading" 
                :internal-search="false" :clear-on-select="true" :close-on-select="true" 
                :options-limit="300" :max-height="600" :show-no-results="false" 
                :hide-selected="true" :taggable="true" 
                :placeholder="$t('project.company.form.firm.company')"
                :select-label="$t('project.company.form.firm.select')"
                :tag-placeholder="$t('project.company.form.firm.add')"
                @search-change="asyncCompanyFind" @tag="addTag">
            </multiselect>

            <span class="text-danger" v-if="errors.has('firm.company')">{{ errors.first('firm.company') }}</span>
        </div>

        <div class="form-group col-md-3">
            <label for="companyInput" v-if="firm.firmType == 1">{{ $t('project.company.form.accounting.name') }}</label>
            <label for="companyInput" v-if="firm.firmType == 2">{{ $t('project.company.form.lawyer.name') }}</label>
            
            <multiselect v-model="localName" id="ajax" open-direction="bottom" 
                label="name" track-by="id"
                :options="names" :multiple="false" :searchable="true" :loading="isLoading" 
                :internal-search="false" :clear-on-select="true" :close-on-select="true" 
                :options-limit="300" :max-height="600" :show-no-results="false" 
                :hide-selected="true" :taggable="true" 
                :placeholder="$t('project.company.form.firm.name')"
                :select-label="$t('project.company.form.firm.select')"
                :tag-placeholder="$t('project.company.form.firm.add')"
                @search-change="asyncNameFind" @tag="addNameTag" @select="onNameSelect">
            </multiselect>

            <span class="text-danger" v-if="errors.has('name')">{{ errors.first('name') }}</span>
        </div>

        <div class="form-group col-md-3">
            <label for="companyInput" v-if="firm.firmType == 1">{{ $t('project.company.form.accounting.phone') }}</label>
            <label for="companyInput" v-if="firm.firmType == 2">{{ $t('project.company.form.lawyer.phone') }}</label>
            
            <input v-model.trim="localFirm.phone" v-mask="'(###) ###-####'"  
                v-validate="{ rules: { regex: phoneRegex() } }" name="phone" type="text" class="form-control" 
                id="phoneInput" placeholder="(999) 999-9999">
            <span class="text-danger" v-if="errors.has('phone')">{{ errors.first('phone') }}</span>
        </div>

        <div class="form-group col-md-3">
            <label for="companyInput" v-if="firm.firmType == 1">{{ $t('project.company.form.accounting.email') }}</label>
            <label for="companyInput" v-if="firm.firmType == 2">{{ $t('project.company.form.lawyer.email') }}</label>
            
            <input v-model.trim="localFirm.email"  v-validate="'email'" name="email" type="text" class="form-control" 
                id="emailInput" v-bind:placeholder="$t('project.company.form.firm.email')">
            <span class="text-danger" v-if="errors.has('email')">{{ errors.first('email') }}</span>
        </div>

      </div>
       
</template>

<script>
  import {FirmServiceClient, FirmDto} from '../../shared/service-clients/service-clients'
  import ServiceFactory from '../../shared/service-clients/serviceClientFactory'
  import CrudMixin from '../../shared/Mixin/CrudMixin'
  import Multiselect from 'vue-multiselect'

  export default {
    name: 'CreateFirm',
    props: {
      firm: {},
    },
    data: function() {
      return {
        localFirm: Object.assign({}, this.firm),
        localName: Object.assign({}, this.firm),
        firms: [],
        names: [],
        isLoading: false,
        name: {},
      }
    },
    mixins: [CrudMixin],
    mounted: function() {
      this.fetchData()
      this.setMode()
    },
    watch: {
      firm: function(val) {
        this.localFirm = Object.assign({}, val)
        this.localName = Object.assign({}, val)
      },
      'localFirm.name': function(val) {
        this.$emit('firmChanged', this.processLocalObject())
      },
      'localFirm.email': function(val) {
        this.$emit('firmChanged', this.processLocalObject())
      },
      'localFirm.company': function(val) {
        this.$emit('firmChanged', this.processLocalObject())
      },
      'localFirm.phone': function(val) {
        this.$emit('firmChanged', this.processLocalObject())
      },
    },
    methods: {
      processLocalObject: function() {
        var firm = new FirmDto()
        firm.init(this.localFirm)
        return firm
      },
      fetchData: function() {},
      asyncCompanyFind: function(query) {
        this.isLoading = true
        let service = ServiceFactory.create(FirmServiceClient)
        let self = this

        service.getCompanyAutoComplet(this.localFirm.firmType, query).then(response => {
          self.firms = response
          self.isLoading = false
        })
      },
      addTag: function(tag) {
        this.localFirm.company = tag
      },
      asyncNameFind: function(query) {
        this.isLoading = true
        let service = ServiceFactory.create(FirmServiceClient)
        let self = this

        service.getNameAutoComplet(this.localFirm.firmType, this.localFirm.company, query).then(response => {
          self.names = response
          self.isLoading = false
        })
      },
      addNameTag: function(tag) {
        this.localFirm.name = tag
        this.localName = {name: tag, id: 9999}
      },
      onNameSelect: function(item) {
        this.localFirm.name = item.name
        this.localFirm.phone = item.phone
        this.localFirm.email = item.email
      },
    },
    components: {
      multiselect: Multiselect,
    },
  }
</script>

<style>


</style>



// WEBPACK FOOTER //
// src/components/projects/CreateFirm.vue